import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatToolbar} from '@angular/material/toolbar';
import {Router} from '@angular/router';

import {AuthService} from '@app/auth/auth.service';
import {PreferencesDialogComponent} from '@app/preferences/preferences-dialog/preferences-dialog.component';
import {PreferencesService} from '@app/preferences/preferences.service';
import {User, UserService} from '@app/shared/user.service';

import {Observable} from 'rxjs';

@Component({
    selector: 'frog-site-toolbar',
    templateUrl: './site-toolbar.component.html',
    styleUrls: ['./site-toolbar.component.scss'],
    imports: [MatToolbar, MatIconButton, MatIcon, AsyncPipe],
})
export class SiteToolbarComponent implements OnInit {
    public user$: Observable<User>;

    constructor(
        private userService: UserService,
        private preferencesService: PreferencesService,
        private matDialog: MatDialog,
        private authService: AuthService,
        private router: Router,
    ) {
        this.user$ = this.authService.user;
    }

    ngOnInit(): void {}

    editPreferences() {
        this.matDialog.open(PreferencesDialogComponent, {
            maxWidth: '900px',
            width: '100%',
            height: '600px',
        });
    }

    logout() {
        this.authService.logout().subscribe();
    }
}
